import { contentInfoType } from "types";

  export const SET_GET_CONTENT_ONCE = () => ({
    type: 'SET_GET_CONTENT_ONCE',
    payload: true
  });  

  export const GET_USER_VIDEOS_SAGA = (payload: { userEmail: string; }) => ({
    type: 'GET_USER_VIDEOS_SAGA',
    payload: payload
  });  


  export const SET_CHANGE_CONTENT = (payload: boolean) => ({
    type: 'SET_CHANGE_CONTENT',
    payload: payload
  });  


  export const SET_SELECTED_APP = (payload: contentInfoType) => ({
    type: 'SET_SELECTED_APP',
    payload: payload
  });  


  export const SET_ALL_CONTENT = (payload: { [key: string]: any }[]) => ({
    type: 'SET_ALL_CONTENT',
    payload: payload
  });  


  export const GET_FATHER_APP_SAGA = (payload: { [key: string]: any }[]) => ({
    type: 'GET_FATHER_APP_SAGA',
    payload: payload
  });  


  export const SAVE_VIDEO_LOCATION_SAGA = (payload: { [key: string]: any }) => ({
    type: 'SAVE_VIDEO_LOCATION_SAGA',
    payload: payload
  });  


  export const SET_USER_VIDEOS = (payload: { [key: string]: any }) => ({
    type: 'SET_USER_VIDEOS',
    payload: payload
  });
  
  
  export const DELETE_USER_VIDEO_SAGA = (payload: { [key: string]: any }) => ({
    type: 'DELETE_USER_VIDEO_SAGA',
    payload: payload
  });
  
  


  


  


  


